import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  type SelectChangeEvent,
} from "@mui/material";
import { DEFAULT_PHONE_DIAL_CODE, PHONE_DIAL_OPTIONS } from "@/constants/phoneDialCodes";

export interface PhoneFieldProps {
  dialCode: string;
  phone: string;
  onDialCodeChange: (dialCode: string) => void;
  onPhoneChange: (phone: string) => void;
  label?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  size?: "small" | "medium";
  fullWidth?: boolean;
  disabled?: boolean;
}

export function PhoneField({
  dialCode,
  phone,
  onDialCodeChange,
  onPhoneChange,
  label = "Téléphone",
  placeholder = "694 12 34 56",
  error = false,
  helperText,
  required = false,
  size = "small",
  fullWidth = true,
  disabled = false,
}: PhoneFieldProps): JSX.Element {
  const normalizedDial = dialCode || DEFAULT_PHONE_DIAL_CODE;

  function handleDialChange(event: SelectChangeEvent<string>): void {
    onDialCodeChange(event.target.value);
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ width: fullWidth ? "100%" : undefined }}
      alignItems="flex-start"
    >
      <FormControl size={size} sx={{ minWidth: 168, flexShrink: 0 }} disabled={disabled}>
        <InputLabel id="phone-dial-code-label">Indicatif</InputLabel>
        <Select
          labelId="phone-dial-code-label"
          value={normalizedDial}
          label="Indicatif"
          onChange={handleDialChange}
        >
          {PHONE_DIAL_OPTIONS.map((option) => (
            <MenuItem key={option.dialCode} value={option.dialCode}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label={label}
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        placeholder={placeholder}
        type="tel"
        size={size}
        required={required}
        error={error}
        helperText={helperText}
        disabled={disabled}
        fullWidth
      />
    </Stack>
  );
}
